import { gql } from '@apollo/client';

export const AdminContentReportsQueryName = 'AdminContentReports';

export const ADMIN_CONTENT_REPORTS_QUERY = gql`
  query ${AdminContentReportsQueryName} {
    adminContentReports {
      id
      reporterUserId
      authorUserId
      entityType
      entityId
      reason
      details
      contentSnapshot
      status
      createdAt
    }
  }
`;
